import { render, staticRenderFns } from "./DuplicateTracker.vue?vue&type=template&id=2a1de5b7&scoped=true&"
import script from "./DuplicateTracker.vue?vue&type=script&lang=js&"
export * from "./DuplicateTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1de5b7",
  null
  
)

export default component.exports